// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
* {
	box-sizing: border-box;
	margin: 0;
	padding: 0;	
	font-family:-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
}

.containerIni{
background-color: #0c1b30;
}

.containerLogin {
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 100vh;
}

.screenLogin {		
	background: linear-gradient(90deg, #0c1b30, #0c1b30);		
	position: relative;	
	height: 100%;
	width: 100%;	
}

.screen__content {
	z-index: 1;
	position: relative;	
	height: 100%;
}

.screen__background {		
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 0;
	clip-path: inset(0 0 0 0);	
}

.screen__background__shape {
	transform: rotate(45deg);
	position: absolute;
}

.screen__background__shape1 {
	height: 520px;
	width: 520px;
	background: #0c1b30;	
	top: -50px;
	right: 120px;	
	border-radius: 0 72px 0 0;
}

.screen__background__shape2 {
	height: 220px;
	width: 220px;
	background: #0c1b30;	
	top: -172px;
	right: 0;	
	border-radius: 32px;
}

.screen__background__shape3 {
	height: 540px;
	width: 190px;
	background: linear-gradient(270deg, #0c1b30, #0c1b30);
	top: -24px;
	right: 0;	
	border-radius: 32px;
}

.screen__background__shape4 {
	height: 400px;
	width: 200px;
	background: #0c1b30;	
	top: 420px;
	right: 50px;	
	border-radius: 60px;
}

.login {
	width: 100%;
	padding: 30px;
	padding-top: 2rem;
}

.login__field {
	padding: 20px 0px;
	width: 90%;	
	display: flex;
	align-items: stretch;
}

.login__icon {
	color: #fff;
	display: flex;
	align-items: center;
}

.divPassLogin{
	width: 95.5%;
}

.login__input {
	border: none;
	border-bottom: 2px solid #D1D1D4;
	background: none;
	padding: 1%;
	margin-left: 1%;
	padding-left: 24px;
	font-weight: 700;
	width: 90%;
	transition: .2s;
}

.login__input:active,
.login__input:focus,
.login__input:hover {
	outline: none;
	border-bottom-color: #0c1b30;
}

.login__submit {
	background: #fff;
	font-size: 14px;
	margin-top: 30px;
	padding: 16px 20px;
	border-radius: 26px;
	border: 1px solid #D4D3E8;
	text-transform: uppercase;
	font-weight: 700;
	display: flex;
	align-items: center;
	width: 80%;
	color: #0c1b30;
	box-shadow: 0px 2px 2px #0c1b30;
	cursor: pointer;
	transition: .2s;
}

.btnIniciaSL{
	display: flex;
	justify-content: center;
}

.login__submit:active,
.login__submit:focus,
.login__submit:hover {
	border-color: #0c1b30;
	outline: none;
}

.button__icon {
	font-size: 24px;
	margin-left: auto;
	color: #0c1b30;
}

.divLogo{
	padding-top: 2rem;
	max-width: auto;
	text-align: center;
}

.imgLogo{
	width: 15rem;
	height: 15rem;
}

.newUserDiv{
	width: 90%;
	text-align: right;

}

.newUserDiv Button{
	color: #FFF;
	font-weight: bold;
}

.swiperDiv{
	margin-top: 3%;
	margin-left: 4%;
	height: 30vh;
}

.mySwiper{
	height: 90vh;
}

.iconMosPass{
	color: #FFF;
	display: flex;
	align-items: center;
	margin-left: 1%;
	margin-top: 1%;
}

.columnLogin{
	--bs-gutter-x: 0;
}
@media screen and (max-width: 768px) {
	.columnLogin{
		margin-left: 5%;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/login/style.css"],"names":[],"mappings":";AACA;CACC,sBAAsB;CACtB,SAAS;CACT,UAAU;CACV,sGAAsG;AACvG;;AAEA;AACA,yBAAyB;AACzB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,iBAAiB;AAClB;;AAEA;CACC,oDAAoD;CACpD,kBAAkB;CAClB,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,UAAU;CACV,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,QAAQ;CACR,SAAS;CACT,UAAU;CAEV,yBAAyB;AAC1B;;AAEA;CACC,wBAAwB;CACxB,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,YAAY;CACZ,mBAAmB;CACnB,UAAU;CACV,YAAY;CACZ,yBAAyB;AAC1B;;AAEA;CACC,aAAa;CACb,YAAY;CACZ,mBAAmB;CACnB,WAAW;CACX,QAAQ;CACR,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,YAAY;CACZ,qDAAqD;CACrD,UAAU;CACV,QAAQ;CACR,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,YAAY;CACZ,mBAAmB;CACnB,UAAU;CACV,WAAW;CACX,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,aAAa;CACb,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;CACjB,UAAU;CACV,aAAa;CACb,oBAAoB;AACrB;;AAEA;CACC,WAAW;CACX,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;CACZ,gCAAgC;CAChC,gBAAgB;CAChB,WAAW;CACX,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,UAAU;CACV,eAAe;AAChB;;AAEA;;;CAGC,aAAa;CACb,4BAA4B;AAC7B;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,yBAAyB;CACzB,yBAAyB;CACzB,gBAAgB;CAChB,aAAa;CACb,mBAAmB;CACnB,UAAU;CACV,cAAc;CACd,+BAA+B;CAC/B,eAAe;CACf,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,uBAAuB;AACxB;;AAEA;;;CAGC,qBAAqB;CACrB,aAAa;AACd;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,iBAAiB;CACjB,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,aAAa;AACd;;AAEA;CACC,UAAU;CACV,iBAAiB;;AAElB;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,YAAY;AACb;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,WAAW;CACX,aAAa;CACb,mBAAmB;CACnB,eAAe;CACf,cAAc;AACf;;AAEA;CACC,gBAAgB;AACjB;AACA;CACC;EACC,eAAe;CAChB;AACD","sourcesContent":["\n* {\n\tbox-sizing: border-box;\n\tmargin: 0;\n\tpadding: 0;\t\n\tfont-family:-apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif;\n}\n\n.containerIni{\nbackground-color: #0c1b30;\n}\n\n.containerLogin {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tmin-height: 100vh;\n}\n\n.screenLogin {\t\t\n\tbackground: linear-gradient(90deg, #0c1b30, #0c1b30);\t\t\n\tposition: relative;\t\n\theight: 100%;\n\twidth: 100%;\t\n}\n\n.screen__content {\n\tz-index: 1;\n\tposition: relative;\t\n\theight: 100%;\n}\n\n.screen__background {\t\t\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tz-index: 0;\n\t-webkit-clip-path: inset(0 0 0 0);\n\tclip-path: inset(0 0 0 0);\t\n}\n\n.screen__background__shape {\n\ttransform: rotate(45deg);\n\tposition: absolute;\n}\n\n.screen__background__shape1 {\n\theight: 520px;\n\twidth: 520px;\n\tbackground: #0c1b30;\t\n\ttop: -50px;\n\tright: 120px;\t\n\tborder-radius: 0 72px 0 0;\n}\n\n.screen__background__shape2 {\n\theight: 220px;\n\twidth: 220px;\n\tbackground: #0c1b30;\t\n\ttop: -172px;\n\tright: 0;\t\n\tborder-radius: 32px;\n}\n\n.screen__background__shape3 {\n\theight: 540px;\n\twidth: 190px;\n\tbackground: linear-gradient(270deg, #0c1b30, #0c1b30);\n\ttop: -24px;\n\tright: 0;\t\n\tborder-radius: 32px;\n}\n\n.screen__background__shape4 {\n\theight: 400px;\n\twidth: 200px;\n\tbackground: #0c1b30;\t\n\ttop: 420px;\n\tright: 50px;\t\n\tborder-radius: 60px;\n}\n\n.login {\n\twidth: 100%;\n\tpadding: 30px;\n\tpadding-top: 2rem;\n}\n\n.login__field {\n\tpadding: 20px 0px;\n\twidth: 90%;\t\n\tdisplay: flex;\n\talign-items: stretch;\n}\n\n.login__icon {\n\tcolor: #fff;\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.divPassLogin{\n\twidth: 95.5%;\n}\n\n.login__input {\n\tborder: none;\n\tborder-bottom: 2px solid #D1D1D4;\n\tbackground: none;\n\tpadding: 1%;\n\tmargin-left: 1%;\n\tpadding-left: 24px;\n\tfont-weight: 700;\n\twidth: 90%;\n\ttransition: .2s;\n}\n\n.login__input:active,\n.login__input:focus,\n.login__input:hover {\n\toutline: none;\n\tborder-bottom-color: #0c1b30;\n}\n\n.login__submit {\n\tbackground: #fff;\n\tfont-size: 14px;\n\tmargin-top: 30px;\n\tpadding: 16px 20px;\n\tborder-radius: 26px;\n\tborder: 1px solid #D4D3E8;\n\ttext-transform: uppercase;\n\tfont-weight: 700;\n\tdisplay: flex;\n\talign-items: center;\n\twidth: 80%;\n\tcolor: #0c1b30;\n\tbox-shadow: 0px 2px 2px #0c1b30;\n\tcursor: pointer;\n\ttransition: .2s;\n}\n\n.btnIniciaSL{\n\tdisplay: flex;\n\tjustify-content: center;\n}\n\n.login__submit:active,\n.login__submit:focus,\n.login__submit:hover {\n\tborder-color: #0c1b30;\n\toutline: none;\n}\n\n.button__icon {\n\tfont-size: 24px;\n\tmargin-left: auto;\n\tcolor: #0c1b30;\n}\n\n.divLogo{\n\tpadding-top: 2rem;\n\tmax-width: auto;\n\ttext-align: center;\n}\n\n.imgLogo{\n\twidth: 15rem;\n\theight: 15rem;\n}\n\n.newUserDiv{\n\twidth: 90%;\n\ttext-align: right;\n\n}\n\n.newUserDiv Button{\n\tcolor: #FFF;\n\tfont-weight: bold;\n}\n\n.swiperDiv{\n\tmargin-top: 3%;\n\tmargin-left: 4%;\n\theight: 30vh;\n}\n\n.mySwiper{\n\theight: 90vh;\n}\n\n.iconMosPass{\n\tcolor: #FFF;\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-left: 1%;\n\tmargin-top: 1%;\n}\n\n.columnLogin{\n\t--bs-gutter-x: 0;\n}\n@media screen and (max-width: 768px) {\n\t.columnLogin{\n\t\tmargin-left: 5%;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
